/**
 * Track entity IDs that exist on the server after loading game detail.
 * When questions/rows from API are an empty array, UI placeholders use local temp IDs —
 * those must not be treated as persisted server IDs during edit/save.
 */
export function collectPersistedIdsFromApiRows<T>(
    apiRows: T[],
    getId: (row: T, index: number) => number | null | undefined
): Set<number> {
    if (apiRows.length === 0) {
        return new Set();
    }

    const ids = new Set<number>();
    apiRows.forEach((row, index) => {
        const id = getId(row, index);
        if (typeof id === "number" && Number.isInteger(id) && id > 0) {
            ids.add(id);
        }
    });
    return ids;
}
